import type { AdMobData, AppAnalyticsData, UserMetricsData } from '../types'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api'

async function fetchJson<T>(endpoint: string): Promise<T> {
  const response = await fetch(`${API_BASE_URL}${endpoint}`)
  if (!response.ok) {
    throw new Error(`API Error: ${response.statusText}`)
  }
  return response.json()
}

export async function fetchAdMobRevenue(): Promise<AdMobData[]> {
  try {
    return await fetchJson<AdMobData[]>('/admob/revenue')
  } catch {
    return getMockAdMobData()
  }
}

export async function fetchAppAnalytics(): Promise<AppAnalyticsData[]> {
  try {
    return await fetchJson<AppAnalyticsData[]>('/analytics/apps')
  } catch {
    return getMockAppAnalytics()
  }
}

export async function fetchUserMetrics(): Promise<UserMetricsData[]> {
  try {
    return await fetchJson<UserMetricsData[]>('/metrics/users')
  } catch {
    return getMockUserMetrics()
  }
}

export async function queryClickHouse(query: string): Promise<unknown[]> {
  return fetchJson<unknown[]>(`/clickhouse?q=${encodeURIComponent(query)}`)
}

function getMockAdMobData(): AdMobData[] {
  return [
    { date: '2024-01-01', revenue: 125.50, impressions: 12500, clicks: 450, ecpm: 10.04 },
    { date: '2024-01-02', revenue: 132.75, impressions: 13200, clicks: 480, ecpm: 10.06 },
    { date: '2024-01-03', revenue: 118.25, impressions: 11800, clicks: 420, ecpm: 10.02 },
    { date: '2024-01-04', revenue: 145.00, impressions: 14500, clicks: 520, ecpm: 10.00 },
    { date: '2024-01-05', revenue: 138.50, impressions: 13800, clicks: 495, ecpm: 10.04 },
    { date: '2024-01-06', revenue: 152.25, impressions: 15200, clicks: 545, ecpm: 10.02 },
    { date: '2024-01-07', revenue: 165.00, impressions: 16500, clicks: 590, ecpm: 10.00 },
  ]
}

function getMockAppAnalytics(): AppAnalyticsData[] {
  return [
    { appName: 'Xantus App', downloads: 15420, activeUsers: 8540, sessions: 45230, crashRate: 0.12 },
    { appName: 'Xantus Pro', downloads: 8750, activeUsers: 5230, sessions: 28450, crashRate: 0.08 },
    { appName: 'Xantus Lite', downloads: 22340, activeUsers: 12890, sessions: 67890, crashRate: 0.15 },
    { appName: 'Xantus Enterprise', downloads: 3250, activeUsers: 2890, sessions: 12450, crashRate: 0.05 },
  ]
}

function getMockUserMetrics(): UserMetricsData[] {
  return [
    { date: '2024-01-01', totalUsers: 45230, newUsers: 1250, activeUsers: 28450, retentionRate: 68.5, avgSessionDuration: 12 },
    { date: '2024-01-02', totalUsers: 45890, newUsers: 1180, activeUsers: 29120, retentionRate: 69.2, avgSessionDuration: 14 },
    { date: '2024-01-03', totalUsers: 46120, newUsers: 1320, activeUsers: 28780, retentionRate: 67.8, avgSessionDuration: 11 },
    { date: '2024-01-04', totalUsers: 46890, newUsers: 1450, activeUsers: 29890, retentionRate: 70.1, avgSessionDuration: 15 },
    { date: '2024-01-05', totalUsers: 47520, newUsers: 1380, activeUsers: 30120, retentionRate: 69.5, avgSessionDuration: 13 },
    { date: '2024-01-06', totalUsers: 48120, newUsers: 1520, activeUsers: 30890, retentionRate: 71.2, avgSessionDuration: 16 },
    { date: '2024-01-07', totalUsers: 48890, newUsers: 1650, activeUsers: 31450, retentionRate: 72.5, avgSessionDuration: 17 },
  ]
}
